export default __webpack_public_path__ + "static/media/2.6b8b5a9b.jpg";